/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-13 09:24:52
 * @LastEditors: K
 * @LastEditTime: 2022-05-26 16:30:08
 */

import { ADMIN_API_PREFIX } from './constant'
import { Request } from './request'

export interface PartnerPlatformListParams {
  size?: number
  current?: number
  platformName?: string
  platformId?: string
  status?: number
}
//  合作机构列表
export const PartnerPlatformList = (
  params: PartnerPlatformListParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/sysplatform/list`,
    method: 'GET',
    params,
  }
}

export interface addPartnerPlatformParams {
  platformName: string
  contactName?: string
  contactPhone?: string
  remark?: string
  id?: number
  status?: number
}
//  修改新增合作平台
export const addPartnerPlatform = (body: addPartnerPlatformParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/sysplatform/submit`,
    method: 'POST',
    body,
  }
}
//   开启/禁用合作平台
export const openCancelPartnerPlatform = (id: string): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/sysplatform/cancel`,
    method: 'POST',
    params: {
      id,
    },
  }
}
